import React from 'react';
import PageList from '../../../components/PageListAPI'
import { loadRentEquipmentWriteOf } from '../../../api/shipment'
import { makeStyles } from '@mui/styles';
import { red } from '@mui/material/colors';

const useStyles = makeStyles(theme => ({
  alarm:{
    color: red[500]
  },
  selected: {},
}));
export default function ArendaEquipmentListWtireOff(props) {
  const classes = useStyles()
  const column = [
    { id: 'name', name: 'Оборудование', },
    { id: 'alarm', name:'Статус', type: 'component', component: ({ obj }) => {
      if(obj.alarm){
        return <div className={classes.alarm}>Срок аренды вышел</div>
      }
      return <div>Аренда не вышла</div>
    }},
    { id: 'serialNumber', name: 'Серийный номер', },
    { id: 'dateStart', name: 'Начало аренды', type: 'date' },
    { id: 'dateEnd', name: 'Окончание аренды', type: 'date' },
  ]
  return (
    <div className='App-paper'>
      <PageList
        name='ArendaEquipmentListWtireOff'
        title='Оборудование на балансе'
        columns={column}
        idName='id'
        loadAPI={{
          querty: {
            idProject: props.match.params.id
          },
          request: loadRentEquipmentWriteOf,
        }}
        tableProps={{
          selected: obj => obj.alarm,
          classes: classes
        }}
        filterProps={[
          {
            arr: [{ value: '1', name: 'Срок аренды вышел' }, { value: '0', name: 'Аренда не вышла' }],
            field: 'alarm',
            name: 'Статус',
            type: 'select'
          },
        ]}
        {...props}
      />
    </div>
  )
}